import React from 'react';
import RequestObjectInputs from './RequestObjectInputs';

const RequestObjectList = ({
  category,
  code,
  field,
  section,
}) => (
  <RequestObjectInputs
    category={category}
    code={code}
    field={field}
    fields={field.fields}
    section={section}
  />
);

export default RequestObjectList;
